import { useEffect } from "react";
import { Logo } from "./Logo";
import { Footer } from "./Footer";

export const LegalSection = ({ title, children }) => (
  <section className="mt-10">
    <h2 className="font-display text-2xl sm:text-3xl text-ink">{title}</h2>
    <div className="mt-3 space-y-3 text-base leading-relaxed text-ink/85">{children}</div>
  </section>
);

export const LegalLayout = ({ title, updated, children, testid }) => {
  useEffect(() => { window.scrollTo(0, 0); }, []);
  return (
    <main className="min-h-screen bg-cream" data-testid={testid}>
      <header className="bg-ink">
        <div className="mx-auto max-w-4xl px-5 sm:px-8 py-5 flex items-center justify-between gap-4">
          <Logo href="/" />
          <a href="/" data-testid="legal-back-home-link" className="text-sm font-semibold text-cream/85 hover:text-butter transition-colors">Back to the shop</a>
        </div>
      </header>
      <article className="mx-auto max-w-3xl px-5 sm:px-8 py-16 sm:py-24">
        <h1 className="font-display text-ink text-5xl sm:text-6xl leading-[0.95]">{title}</h1>
        <p className="mt-4 text-sm text-ink/70">Last updated: {updated}</p>
        {children}
      </article>
      <Footer />
    </main>
  );
};
